var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmendoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.7 -1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.7 1.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.043,12.2A11.244,11.244,0,0,0,31.69,6.888C30.675,4.966,29.1,4.4,27.18,5.305a14.919,14.919,0,0,0-2.255,1.357c-.225.226-.564.339-.789.565a1.98,1.98,0,0,0-.564.452h0V7.454a22.107,22.107,0,0,1,.9-4.749h0c0-.226.113-.452,0-.678a.417.417,0,0,0-.338-.226.8.8,0,0,0-.676.339,18.586,18.586,0,0,0-2.48,4.41,2.4,2.4,0,0,1-.338.792h0c-.113-.226-.338-.565-.451-.792a10.745,10.745,0,0,0-1.127-1.922,9.18,9.18,0,0,0-2.029-2.148,2.59,2.59,0,0,0-3.5,0A6.955,6.955,0,0,0,11.96,4.061c-.9,1.357-1.578,2.714-2.255,3.958-.225.452-.451,1.018-.676,1.47a.858.858,0,0,1-.225.452L8.69,9.828A20.31,20.31,0,0,0,2.489,4.4h0a1.133,1.133,0,0,0-.338-.113c-.225,0-.451,0-.451.226v.565c0,.113.113.226.225.339h0a20.867,20.867,0,0,1,4.961,9.5A1.022,1.022,0,0,0,7,15.482a5.521,5.521,0,0,1,.225,2.375H6.773c-.225,0-.338,0-.451.113a1.172,1.172,0,0,0-.113.452A23.347,23.347,0,0,0,7.563,26.9c1.691,4.3,4.961,6.332,9.47,5.767a6.066,6.066,0,0,1,2.819.339,10.343,10.343,0,0,0,3.5.792,7.64,7.64,0,0,0,6.314-3.618,20.708,20.708,0,0,0,2.029-3.845,32.13,32.13,0,0,0,1.917-14.021ZM7.563,14.351A24.35,24.35,0,0,0,4.406,7.114h0a20.822,20.822,0,0,1,3.721,3.958c.113.226.225.339,0,.678a16.571,16.571,0,0,0-.564,2.261v.339Zm.564,3.505c.338-4.636,2.931-11.873,5.524-14.021-1.578,4.523-1.917,9.272-2.255,13.908h0A31.591,31.591,0,0,1,8.126,17.857ZM16.92,3.722c.113,0,.225.226.338.339a12.826,12.826,0,0,1,2.593,4.184,30.441,30.441,0,0,1,2.593,9.272v.339h-3.27V17.63c-.451-4.523-.789-9.272-2.368-13.8Zm-4.51,14.134V15.708a51.122,51.122,0,0,1,1.8-10.629,18.794,18.794,0,0,1,.676-1.809c0-.226.113-.226.225-.226h0s.113,0,.225.226a9.5,9.5,0,0,1,.789,2.148,54.811,54.811,0,0,1,1.8,12.438H12.411Zm9.7-6.784v-.226a17.247,17.247,0,0,1,4.735-4.184c.225-.113.564-.226.789-.339h0a35.059,35.059,0,0,0-4.51,7.237l-.338.565v-.452c-.338-.9-.564-1.7-.789-2.488Zm.676-5.314a23.873,23.873,0,0,1-.225,2.827,1.034,1.034,0,0,1-.338.565c-.113.226-.338.339-.451.565h0a1.445,1.445,0,0,1,0-1.357c.338-.678.564-1.357.9-2.035.113-.339.225-.565.338-.9v.226Zm.451,18.092a13.285,13.285,0,0,1-1.466,4.071,7.184,7.184,0,0,1-6.539,3.845h0A6.985,6.985,0,0,1,8.69,27.92a18.02,18.02,0,0,1-1.8-6.558V18.987h16.8A22.952,22.952,0,0,1,23.234,23.849Zm.451,2.261A26.507,26.507,0,0,0,24.7,18.535c0-.226,0-.452-.225-.565a1.164,1.164,0,0,0-.451-.113h-.451V17.4a5.691,5.691,0,0,1-.225-1.357V15.6a46.757,46.757,0,0,1,4.51-7.689c.451-.565.9-1.018,1.24-1.47a1.621,1.621,0,0,0,.338-.226h0c0,.113.113.226.113.339V9.6a61.486,61.486,0,0,1-4.51,17.074,29.872,29.872,0,0,1-1.691,3.279,7.164,7.164,0,0,1-1.24,1.47,2.105,2.105,0,0,1-2.819.452c2.142-1.131,3.5-2.94,4.4-5.767ZM25.6,28.033a54.562,54.562,0,0,0,3.946-12.325c.338-1.809.676-3.731.9-5.541a5.691,5.691,0,0,1,.225-1.357V7.341c0,.113.113.226.225.339a10.853,10.853,0,0,1,1.015,4.184,31.763,31.763,0,0,1-2.029,14.7,10.537,10.537,0,0,1-2.593,4.071,6.388,6.388,0,0,1-5.073,2.035h0a13.965,13.965,0,0,0,3.27-4.636Z",
    transform: "translate(-1.7 -1.8)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,19.1H9a.481.481,0,0,0-.2.6.43.43,0,0,0,.4.4h.1a.55.55,0,0,0,.5-.3,1.2,1.2,0,0,0-.2-.8Z",
    transform: "translate(-0.766 0.54)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2,20.1h.1a.622.622,0,0,0,.6-.4h0c0-.2,0-.4-.2-.5a.6.6,0,0,0-.7,0c-.2,0-.3.2-.3.4a.634.634,0,0,0,.5.6Z",
    transform: "translate(-0.369 0.553)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,19.1c-.3,0-.6,0-.7.3v.5a.764.764,0,0,0,.5.2h.1a.43.43,0,0,0,.4-.4h0c0-.3,0-.5-.4-.6Z",
    transform: "translate(0.03 0.545)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,19.1a1.2,1.2,0,0,0-.8.2v.5a.764.764,0,0,0,.5.2h.1a.43.43,0,0,0,.4-.4h0c0-.3,0-.5-.3-.6Z",
    transform: "translate(0.413 0.531)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1,22.1a.829.829,0,0,0-.8.3v.5a.764.764,0,0,0,.5.2h0a.43.43,0,0,0,.4-.4h0c0-.3,0-.5-.3-.6Z",
    transform: "translate(-0.568 0.951)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,22.1a.778.778,0,0,0-.8.2v.5c.1.2.3.2.5.2h0a.43.43,0,0,0,.4-.4h0c0-.3,0-.5-.3-.7Z",
    transform: "translate(-0.187 0.934)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,22.1c-.3,0-.6,0-.7.3v.5a.764.764,0,0,0,.5.2h.1a.43.43,0,0,0,.4-.4h0c0-.3,0-.5-.4-.6Z",
    transform: "translate(0.228 0.951)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,25.1a.778.778,0,0,0-.8.2v.5c.1.2.3.2.5.2h0a.43.43,0,0,0,.4-.4h0c0-.3,0-.5-.3-.7Z",
    transform: "translate(-0.384 1.9)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,25.1c-.3,0-.6,0-.7.3v.5a.764.764,0,0,0,.5.2h.1a.43.43,0,0,0,.4-.4h0c0-.3,0-.5-.4-.6Z",
    transform: "translate(0.03 1.9)",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmendoal);
export default __webpack_public_path__ + "static/media/amendoal.03a9a2fde04f5b8bca32a2297b33147a.svg";
export { ForwardRef as ReactComponent };